import { boolean, object, ObjectSchema } from 'yup';

import { FormErrorMessage } from '~/constants/messages';

import { Fields } from './types';

export const validationSchema: ObjectSchema<Fields> = object({
  statusManagement: boolean().label('フォローアップ管理設定').required(FormErrorMessage.required),
});
